import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const parkingVehicleKeys = {
    all: ['parkingVehicles'],
    get: (filter) => ['parkingVehicles', filter],
};
export const parkingVehicleOptions = {
    get: (filter) => queryOptions({
        queryKey: parkingVehicleKeys.get(filter),
        queryFn: async () => {
            const repository = await resolveRepository(Domain.ParkingVehicle);
            return repository.get(filter);
        },
    }),
    create: () => ({
        mutationFn: async (request) => {
            const repository = await resolveRepository(Domain.ParkingVehicle);
            return repository.create(request);
        },
    }),
    update: () => ({
        mutationFn: async (request) => {
            const repository = await resolveRepository(Domain.ParkingVehicle);
            return repository.update(request);
        },
    }),
    remove: () => ({
        mutationFn: async (id) => {
            const repository = await resolveRepository(Domain.ParkingVehicle);
            return repository.remove(id);
        },
    }),
};
